import firebase from 'firebase/app';
import 'firebase/storage';
import { JoyUploadServiceAction, JoyUploadServiceUploadType, JoyUploadSessionStatus, isJoyUploadSessionType, JoyField, isString, isArrayBuffer, isUrl, isJoyPropertiesArray, isStringMap, } from 'joy-core';
import StorageUploadTask from '../tasks/StorageUploadTask';
import { fromFirestore, toFirestore, toFirestoreUploadAction } from '../support/FirestoreConversion';
import { callAPI } from '../support/JoyAPISupport';
export default class StorageUploadServiceProvider {
    createUploadSession(data) {
        return this.perform(JoyUploadServiceAction.create, data);
    }
    getUploadSession(id) {
        let data = new Map();
        data[JoyField.id] = id;
        return this.perform(JoyUploadServiceAction.get, data);
    }
    async getUploadSessions(data) {
        let method = 'getUploadSessions';
        let params = toFirestore(data);
        let result = await callAPI(method, params);
        if (isStringMap(result)) {
            return Object.keys(result).map((value) => ({
                groupId: value,
                sessionIds: result[value],
            }));
        }
        else {
            throw Error('Invalid data received for UploadSession');
        }
    }
    addToUploadSession(data) {
        return this.perform(JoyUploadServiceAction.addMedia, data);
    }
    closeUploadSession(id) {
        let data = new Map();
        data[JoyField.id] = id;
        return this.perform(JoyUploadServiceAction.delete, data);
    }
    upload(type, data, completion, progressHandler) {
        let userId = data[JoyField.user];
        if (!isString(userId)) {
            throw Error('Invalid userId');
        }
        let buffer = data[JoyField.data];
        if (!isArrayBuffer(buffer)) {
            throw Error('Invalid buffer');
        }
        let ref = firebase.storage().ref().child('users').child(userId);
        let metadata = null;
        switch (type) {
            case JoyUploadServiceUploadType.media:
                let mediumId = data[JoyField.medium];
                if (!isString(mediumId))
                    throw Error('Invalid mediumId');
                let mimeType = data[JoyField.mimeType];
                if (!isString(mimeType))
                    throw Error('Invalid mimeType');
                let extension = data[JoyField.extension];
                if (!isString(extension))
                    throw Error('Invalid extension');
                ref = ref.child('media').child(mediumId + `.${extension}`);
                metadata = { contentType: mimeType };
                break;
            case JoyUploadServiceUploadType.voiceNote:
                let commentId = data[JoyField.comment];
                if (isString(commentId)) {
                    ref = ref.child('voice-notes').child(commentId);
                }
                else {
                    throw Error('Invalid commentId');
                }
                break;
            case JoyUploadServiceUploadType.avatar:
                ref = ref.child('avatar.jpg');
                break;
            default:
                break;
        }
        let task = metadata ? ref.put(buffer, metadata) : ref.put(buffer);
        return new StorageUploadTask(task, (url, error) => {
            if (isUrl(url)) {
                completion(url);
            }
            else {
                completion(error);
            }
        }, (progress) => {
            progressHandler(progress);
        });
    }
    async perform(action, data) {
        let method = toFirestoreUploadAction(action) + 'UploadSession';
        let params = toFirestore(data);
        let result = await callAPI(method, params);
        if (result !== null) {
            let output = fromFirestore(result);
            if (action === JoyUploadServiceAction.create) {
                if (isJoyUploadSessionType(data[JoyField.sessionType])) {
                    output[JoyField.sessionType] = data[JoyField.sessionType];
                }
                if (isJoyPropertiesArray(data[JoyField.props])) {
                    output[JoyField.props] = data[JoyField.props];
                }
                output[JoyField.status] = JoyUploadSessionStatus.started;
            }
            return output;
        }
        else {
            throw Error('Invalid data received for UploadSession');
        }
    }
}
//# sourceMappingURL=StorageUploadServiceProvider.js.map